import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "@/assets/css/common.scss"
import App from './App.vue'
import router from './router'
import './style.css'
import 'animate.css'
import lazy from './directives/lazy'
// 导入语言包
import { createI18n } from 'vue-i18n';
import zhCN from '@/i18n/zh-CN.json';
import zhHK from '@/i18n/zh-HK.json';
import en from '@/i18n/en.json';
import ru from '@/i18n/ru.json';
const app = createApp(App)
// i18n 配置
const messages = {
  'cn': zhCN,
  'tc': zhHK,
  'en': en,
  'ru': ru,
};

const i18n = createI18n({
  locale: 'cn', // 默认语言
  fallbackLocale: 'en', // 备用语言
  messages,
  legacy: false, // 使用 Composition API 模式
  globalInjection: true, // 全局注入 $t 等
});
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(i18n);
app.use(ElementPlus)
app.use(router)
app.directive('lazy', lazy)
app.mount('#app')
